<template>
  <div class="termos-page container-fluid min-vh-100">
    <div class="row min-vh-100 justify-content-center">
      <div class="col-12 col-lg-8 d-flex justify-content-center">
        <div class="termos-card w-100">

          <!-- VOLTAR -->
          <router-link to="/create-account" class="voltar mb-4 d-inline-flex align-items-center">
            <b>← Voltar</b>
          </router-link>

          <!-- TÍTULO -->
          <div class="page-header">
            <p class="page-header-eyebrow">LEGAL</p>
            <h3 class="fw-bold mb-2"><b>Política de Privacidade</b></h3>
            <p class="text-muted mb-4">
              Última atualização: {{ dataAtual }}
            </p>
          </div>

          <!-- CONTEÚDO -->
          <div class="termos-conteudo">

            <h5>1. Coleta de Informações</h5>
            <p>
              Coletamos informações fornecidas diretamente pelo usuário no momento do
              cadastro, como nome, CPF, e-mail, telefone e empresa.
            </p>

            <h5>2. Uso das Informações</h5>
            <p>
              As informações coletadas são utilizadas para:
            </p>
            <ul>
              <li>Criação e gerenciamento de contas</li>
              <li>Gerenciamento de projetos e componentes</li>
              <li>Controle de acesso e segurança</li>
              <li>Processamento de assinaturas e pagamentos</li>
              <li>Comunicação sobre o uso da plataforma</li>
            </ul>

            <h5>3. Compartilhamento de Dados</h5>
            <p>
              Os dados pessoais não são vendidos ou compartilhados com terceiros,
              exceto quando necessário para:
            </p>
            <ul>
              <li>Processamento de pagamentos recorrentes</li>
              <li>Cumprimento de obrigações legais</li>
              <li>Funcionamento técnico da plataforma</li>
            </ul>

            <h5>4. Armazenamento e Segurança</h5>
            <p>
              As informações são armazenadas em ambiente seguro, com medidas técnicas
              e organizacionais adequadas para proteger os dados contra acesso não
              autorizado.
            </p>

            <h5>5. Cookies e Tecnologias Semelhantes</h5>
            <p>
              Podemos utilizar cookies e tecnologias similares para melhorar a
              experiência do usuário e o desempenho da plataforma.
            </p>

            <h5>6. Direitos do Usuário</h5>
            <p>
              O usuário possui o direito de:
            </p>
            <ul>
              <li>Acessar, corrigir ou atualizar seus dados pessoais</li>
              <li>Solicitar a exclusão de sua conta e dados</li>
              <li>Revogar consentimentos concedidos</li>
            </ul>

            <h5>7. Retenção dos Dados</h5>
            <p>
              Os dados serão mantidos enquanto a conta estiver ativa ou conforme
              exigido por lei.
            </p>

            <h5>8. Alterações desta Política</h5>
            <p>
              Esta Política de Privacidade pode ser atualizada periodicamente.
              Alterações relevantes serão comunicadas na plataforma.
            </p>

            <h5>9. Contato</h5>
            <p>
              Em caso de dúvidas sobre esta Política de Privacidade, o usuário pode
              entrar em contato por meio dos canais disponibilizados na plataforma.
            </p>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Privacidade",
  mounted() {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  },
  computed: {
    dataAtual() {
      return new Date().toLocaleDateString("pt-BR");
    }
  }
};
</script>

<style scoped>
.termos-page {
  background: #ffffff;
}

.termos-card {
  max-width: 720px;
  padding: 32px;
}

.voltar {
  color: #0056ff;
  text-decoration: none;
  font-weight: 500;
}

.voltar:hover {
  text-decoration: underline;
}

.termos-conteudo {
  padding-right: 8px;
}

.termos-conteudo h5 {
  margin-top: 24px;
  font-weight: 700;
}

.termos-conteudo p,
.termos-conteudo li {
  color: #555;
  font-size: 0.95rem;
  line-height: 1.6;
}
</style>
